import React from "react";
import { useStyles } from "../../assets/jss/PageLoader";
import Loader from "../../assets/images/loader.gif";

const PageLoader = (props: any) => {
  const classes = useStyles();
  const { apiStatus } = props
  console.log(apiStatus)
  return (
    <div className={classes.pageLoader}>
      <div>
        <img src={Loader} className={classes.pageLoaderImg} alt="" />
        {
          apiStatus && apiStatus.status && (apiStatus.status.code === 401 || apiStatus.status.code === 1001) && (
            <div className={classes.pageLoaderBox}>
              <div className={classes.pageLoaderBoxCode}>
                {apiStatus.status.code}
              </div>
              <div className={classes.pageLoaderBoxMessage}>
                {apiStatus.status.message}
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default PageLoader;
